import React, { Component } from 'react';
import { Row, Col, Card, Drawer } from 'antd';
import Button from '../../common/atoms/DSButton';
import ActivitiesDrawer from './ActivitiesDrawer'
import {ActivityImproveImage} from '../../../assets/images';
const { Meta } = Card;

class Activities extends Component {
  constructor(props) {
      super(props);
      this.state = {
        showActivitiesModal: false
      };
  }

  showActivityModal = () => {
    this.setState({showActivitiesModal: true})
  }

  handleCancel = (e) => {
    this.setState({
      showActivitiesModal: false
      });
  }

  handleClose = (e) => {
    this.setState({
      showActivitiesModal: false
    });
  }

  cancelModal(e){
    this.setState({showActivitiesModal: false})
  }

  renderModal(){
    if (this.state.showActivitiesModal) {
      return(<Drawer
        title={<span className="text-ts-xl font-fig-semibold text-gray-900">Recommended Activities</span>}
        width={'30%'}
        visible={this.state.showActivitiesModal}
        onCancel={this.handleCancel}
        onClose={this.handleClose}
        footer={null}
        bodyStyle={{ paddingBottom: 24 }}
        >
        <ActivitiesDrawer visible={this.state.showActivitiesModal}
                        closeModal={this.cancelModal.bind(this)}/>
        </Drawer>
      )  
    } else {
      return(<div/>)
    }  
  } 

  render () {
    return(
      <div>
        <Card className="health-check-utilization-card bg-ds-green-lt" style={{marginBottom: 30,marginTop: 10,minHeight: 153}}>
          <Row>
            <Col span={8}>
              <h4 className="sub-heading-title text-ds-green">HOW TO IMPROVE ?</h4>
              <h5>Please have a look at the recommended activities you can enroll to improve the <span className="font-semibold">Lifestyle</span> of your company</h5>
              <Row gutter={8} style={{paddingTop: 16,position: 'absolute'}}>
                <Button type="default" size="small" onClick={() =>this.showActivityModal()} className="text-gray-700">View activities</Button>
              </Row>  
            </Col>
            <Col span={16}>
              <Row type="flex" justify="end">
                <img src={ActivityImproveImage}/>
              </Row>  
            </Col>
          </Row>
        </Card>
        {this.renderModal()} 
      </div>
    )
  }    
}
export default Activities;